<template>
  <div class="user-list">
    <h3>提现管理</h3>
    <el-form
      :inline="true"
      class="demo-form-inline"
      v-loading="loading"
      size="mini"
    >
      <el-form-item>
        <el-input v-model="filter.username" placeholder="用户名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="filter.withdrawId" placeholder="流水"></el-input>
      </el-form-item>
      <el-form-item label="审核状态">
        <el-select v-model="filter.statusAudit">
          <el-option value="" label="全部"></el-option>
          <el-option value="yes" label="通过"></el-option>
          <el-option value="no" label="未通过"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="提现状态">
        <el-select v-model="filter.statusWithdraw">
          <el-option label="全部" value=""></el-option>
          <el-option value="reject" label="驳回申请"></el-option>
          <el-option value="submit" label="未审核"></el-option>
          <el-option value="wait" label="待打款"></el-option>
          <el-option value="yes" label="已打款"></el-option>
          <el-option value="no" label="失败"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="开始时间">
        <el-date-picker
          v-model="filter.startTime"
          type="datetime"
          placeholder="选择日期时间"
          align="center"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="结束时间">
        <el-date-picker
          v-model="filter.endTime"
          type="datetime"
          placeholder="选择日期时间"
          align="center"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="search" size="mini">查询</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>

    <el-table :data="list" size="mini">
      <!--<el-table-column type="expand">-->
      <!--<template slot-scope="props">-->
      <!--dsds-->
      <!--</template>-->
      <!--</el-table-column>-->
      <el-table-column type="expand">
        <template slot-scope="scope">
          <template v-if="!scope.row.pass">
            <el-form size="mini">
              <el-form-item label="审核状态">
                <el-radio-group v-model="scope.row.statusAudit2">
                  <el-radio-button label="yes">允许</el-radio-button>
                  <el-radio-button label="no">拒绝</el-radio-button>
                </el-radio-group>
                <el-form-item>
                  <el-button @click="update(scope.row)">更新</el-button>
                </el-form-item>
              </el-form-item>
            </el-form>
          </template>
          <template v-else>
            <el-alert title="本次提现已通过审核，禁止操作" type="warning">
            </el-alert>
          </template>
        </template>
      </el-table-column>
      <el-table-column
        prop="withdrawId"
        label="流水号"
        width="250px"
      ></el-table-column>
      <el-table-column prop="amount" label="提现金额" width="100px">
        <template slot-scope="scope">
          {{ scope.row.amount / 100 }}
        </template>
      </el-table-column>
      <el-table-column prop="amountFinal" label="最终提现额">
        <template slot-scope="scope">
          {{ scope.row.amountFinal / 100 }}元
        </template>
      </el-table-column>
      <el-table-column prop="username" label="用户"></el-table-column>
      <el-table-column prop="userid" label="用户id"></el-table-column>

      <el-table-column prop="type" label="类型"></el-table-column>

      <el-table-column prop="statusAudit" label="审核状态">
        <template slot-scope="scope">
          <el-tag
            type="primary"
            v-if="scope.row.statusAudit === 'yes'"
            size="mini"
          >
            已审核
          </el-tag>
          <el-tag type="danger" v-else size="mini"> 未审核 </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="statusWithdraw" label="提现状态态">
        <template slot-scope="scope">
          <p
            type="primary"
            v-if="scope.row.statusWithdraw === 'reject'"
            size="mini"
          >
            驳回申请
          </p>
          <p
            type="primary"
            v-if="scope.row.statusWithdraw === 'submit'"
            size="mini"
          >
            未审核
          </p>
          <p
            type="warning"
            v-if="scope.row.statusWithdraw === 'wait'"
            size="mini"
          >
            待打款
          </p>
          <p
            type="danger"
            v-if="scope.row.statusWithdraw === 'yes'"
            size="mini"
          >
            已打款
          </p>
          <p type="danger" v-if="scope.row.statusWithdraw === 'no'" size="mini">
            失败
          </p>
        </template>
      </el-table-column>
      <el-table-column prop="userAudit" label="审核人"></el-table-column>
      <el-table-column
        prop="createTime"
        label="申请提现时间"
        width="300px"
      ></el-table-column>
    </el-table>
    <br />
    <div style="float: right">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="20"
        @current-change="(i) => (page = i)"
        :page-count="page"
        :total="total"
        ref="pagination"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import api from "../api";
const { get } = api;

import moment from "moment";

export default {
  name: "user-list",
  data() {
    return {
      loading: true,

      list: [],
      roles: [],
      total: 0,
      page: 1,
      filter: {
        withdrawId: "",
        statusAudit: "",
        userid: "",
        username: "",
        statusWithdraw: "",
        startTime: "",
        endTime: "",
      },
    };
  },
  watch: {
    page() {
      this.fetch();
    },
  },
  methods: {
    async fetch() {
      let pageNum = this.page;
      this.loading = true;
      let {
        statusAudit,
        withdrawId,
        statusWithdraw,
        username,
        startTime,
        endTime,
      } = this.filter;
      let obj = {
        start: (pageNum - 1) * 20,
        statusAudit,
        withdrawId,
        statusWithdraw,
        username,
        startTime,
        endTime,
      };
      if (obj.startTime && obj.endTime) {
        obj.startTime = Date.parse(obj.startTime);
        obj.endTime = Date.parse(obj.endTime);
      }
      if (obj.startTime && !obj.endTime) {
        obj.endTime = Date.now();
        obj.startTime = Date.parse(obj.startTime);
      }
      let res = await get.list(obj);
      let list = res.data.data.map((item) => {
        item.pass = item.statusAudit === "yes";
        item.statusAudit2 = "";
        return item;
      });
      this.list = list;
      this.loading = false;
      this.total = res.data.pageinfo.totalCount;
    },
    async update(item) {
      let { amount, withdrawId, statusAudit, statusAudit2 } = item;
      if (statusAudit2 === "") {
        this.$message.error("请选择允许或拒绝");
        return;
      }
      let res = await get.update({
        amount,
        statusAudit: statusAudit2,
        withdrawId,
        statusPass: "yes",
      });

      let { code } = res.data;
      if (code === 200) {
        this.$message.success("更新数据成功 ");
      }
      this.fetch();
    },
    async search() {
      this.$refs.pagination.internalCurrentPage = 1;
      this.page = 1;
      this.fetch();
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>

<style>
.user-list {
}
</style>



// WEBPACK FOOTER //
// src/views/order/get.vue